<template>
  <div class="recharge-page" :class="{ 'gem-mode': activeRechargeType === 'gems' }">
    <Header no_recharge />

    <!-- 主要内容区域 -->
    <div class="recharge-container">
      <!-- 标题区域 - 在卡片外面 -->
      <!-- <div class="page-header">
        <img src="@/img/recharge/oumi_coin.webp" :alt="$t('recharge.oumiCoin')" class="coin-icon">
        <h1 class="page-title">{{ $t('recharge.oumiTopUp') }}</h1>
      </div> -->
      <div class="first-bg">
        <div class="card-title">{{ $t('recharge.firstTopUpGift') }}</div>
        <div class="card-description">{{ $t('recharge.firstTopUpGiftDescription') }}</div>
        <img src="@/img/recharge/recharge_gift.webp" alt="" class="gift-icon">
      </div>
      <!-- 充值卡片 -->
      <div class="recharge-card">
        <RechargeTypeTabs
          class="currency-tabs"
          :active="activeRechargeType"
          @change="switchRechargeType"
        />

        <!-- 用户ID输入 -->
        <div class="input-section">
          <label class="input-label">{{ $t('recharge.userId') }}</label>
          <div class="input-panel" :class="{ 'has-user': user }">
            <input
              type="text"
              v-model="user_id"
              class="user-input"
              @blur="saveUid"
              @keyup="checkUid"
              :placeholder="$t('recharge.enterUserIdToTopUp')"
            />

            <!-- 用户信息显示 -->
            <div v-if="user" class="user-info">
              <img :src="user.avatar" class="user-avatar">
              <div class="user-details">
                <div class="user-name">{{ user.nickName }}</div>
                <!-- <div class="user-uid">UID: {{ user.userId }}</div> -->
              </div>
              <div v-if="isNewUser" class="first-top-up">{{ $t('recharge.firstTopUp') }}</div>
            </div>
          </div>
        </div>

        <!-- 金币选择区域 -->
        <div v-if="showRechargeOptions || rechargeOptionsLoading" class="amount-section">
          <label class="section-label">{{ $t('recharge.selectTopUpAmount') }}</label>
          <div v-if="rechargeOptionsLoading" class="coin-options" aria-busy="true">
            <div v-for="index in 6" :key="index" class="coin-option option-skeleton"></div>
          </div>
          <div v-else class="coin-options">
            <div 
              v-for="item in recharge_list" 
              :key="item.id"
              class="coin-option"
              :class="{
                active: item.id === select_recharge_id,
                disabled: activeRechargeType === 'gems' && !gemRechargeAllowed,
              }"
              :aria-disabled="activeRechargeType === 'gems' && !gemRechargeAllowed"
              @click="priceChangeHandle(item)"
            >
              <div class="coin-amount">
                <img
                  :src="activeRechargeType === 'gems' ? gemIcon : coinIcon"
                  :alt="activeRechargeType === 'gems' ? 'gem' : $t('recharge.coin')"
                  class="coin-icon-small"
                >
                {{ getRechargeAmount(item) }}
              </div>
            </div>
          </div>
        </div>

        <!-- 支付按钮 -->
        <div v-if="showPaymentOptions && !rechargeOptionsLoading" class="payment-section">
          <div v-if="isPhilippineCoinUser" class="ph-coin-top-up-hint">
            {{ $t('recharge.philippineCoinTopUpHint') }}
          </div>
          <button
            v-if="isPhilippineCoinUser"
            type="button"
            class="guild-top-up-button ph-coin-top-up-button"
            :disabled="!canSubmitPhilippineCoins || !!clickPayItem"
            @click="philippineCoinTopUpClick"
          >
            <span v-if="clickPayItem" class="ph-coin-button-loading">{{ $t('recharge.paying') }}</span>
            <span v-else class="ph-coin-button-content">
              <span class="ph-coin-button-action">{{ $t('recharge.topUp') }}</span>
              <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
              <span class="original-price">{{ getCoinOriginalPrice(select_recharge_item) }}</span>
            </span>
            <PaymentDiscountBadge
              v-if="!clickPayItem"
              class="ph-coin-discount-badge"
              :label="getPaymentDiscount(select_recharge_item?.supportedPayType)"
              featured
            />
          </button>
          <button
            v-if="isGuildGemUser"
            type="button"
            class="guild-top-up-button"
            :disabled="!select_recharge_item || clickPayItem"
            @click="guildGemTopUpClick"
          >
            <span v-if="clickPayItem">{{ $t('recharge.paying') }}</span>
            <span v-else class="gem-top-up-button-content">
              <span>Top-Up Now</span>
              <span>{{ getRechargePrice(select_recharge_item) }}</span>
            </span>
          </button>
          <!-- <button 
              class="payment-button"
              @click="stripePayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'STRIPE' }">
                <div v-if="clickPayItem === 'STRIPE'" class="loading-spinner"></div>
                <img src="@/img/ic_stripe.svg" :alt="$t('recharge.stripe')" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'STRIPE' ? $t('recharge.paying') : $t('recharge.stripePay') }}</span>
                <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
            </button> -->

            <!-- <button 
              class="payment-button"
              @click="airwallexPayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content">
                <img src="@/img/ic_airwallex.svg" :alt="$t('recharge.airwallex')" class="payment-icon">
                <span class="payment-text">{{ $t('recharge.airwallex') }}</span>
                <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
            </button> -->
          <!-- 遍历所有支持的支付方式 -->
          <div v-for="payType in visiblePayTypes" v-show="!isGuildGemUser && !isPhilippineCoinUser" :key="payType" class="payment-method">
            <!-- Stripe 支付 -->
            <button 
              v-if="(payType === 'STRIPE' || payType === 'DIANDIAN') && isPaymentMethodAvailable(payType)"
              class="payment-button"
              @click="stripePayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'STRIPE' }">
                <div v-if="clickPayItem === 'STRIPE'" class="loading-spinner"></div>
                <img src="@/img/ic_stripe.svg" :alt="$t('recharge.stripe')" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'STRIPE' ? $t('recharge.paying') : $t('recharge.stripePay') }}</span>
                <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
              <PaymentDiscountBadge :label="getPaymentDiscount(payType)" />
            </button>

            <!-- PayerMax 支付 -->
            <button 
              v-else-if="['PAYERMAX', 'PAYERMAX_QRPH'].includes(payType) && isPaymentMethodAvailable(payType)"
              class="payment-button"
              @click="payermaxClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: ['PAYERMAX', 'PAYERMAX_QRPH'].includes(clickPayItem) }">
                <div v-if="['PAYERMAX', 'PAYERMAX_QRPH'].includes(clickPayItem)" class="loading-spinner"></div>
                <img src="@/img/ic_payermax.svg" :alt="$t('recharge.payermax')" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'PAYERMAX' ? $t('recharge.paying') : $t('recharge.payermax') }}</span>
                <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
              <PaymentDiscountBadge :label="getPaymentDiscount(payType)" featured />
            </button>

            <!-- PayPal 支付 -->
            <button 
              v-else-if="payType === 'PAYPAL' && isPaymentMethodAvailable(payType)"
              class="payment-button"
              @click="customPaypalClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'PAYPAL' }">
                <div v-if="clickPayItem === 'PAYPAL'" class="loading-spinner"></div>
                <img src="@/img/ic_paypal.svg" :alt="$t('recharge.paypal')" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'PAYPAL' ? $t('recharge.paying') : $t('recharge.paypal') }}</span>
                <span class="payment-price">{{ getPaymentPrice(paypal_product_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
              <PaymentDiscountBadge :label="getPaymentDiscount(payType)" />
            </button>

            <!-- PINGPONG 支付 -->
            <button 
              v-else-if="['PINGPONG', 'PINGPONG_QRPH'].includes(payType) && isPaymentMethodAvailable(payType)"
              class="payment-button"
              @click="pingpongClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: ['PINGPONG', 'PINGPONG_QRPH'].includes(clickPayItem) }">
                <div v-if="['PINGPONG', 'PINGPONG_QRPH'].includes(clickPayItem)" class="loading-spinner"></div>
                <img src="@/img/ic_pingpong.png" :alt="$t('recharge.pingpong')" class="pp-payment-icon">
                <!-- <span class="payment-text">{{ clickPayItem === 'PINGPONG' ? $t('recharge.paying') : $t('recharge.pingpong') }}</span> -->
                <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
              <PaymentDiscountBadge :label="getPaymentDiscount(payType)" />
            </button>


            <!-- DIANDIAN 支付 -->
            <!-- <button 
              v-else-if="payType === 'DIANDIAN'"
              class="payment-button"
              @click="diandianPayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'DIANDIAN' }">
                <div v-if="clickPayItem === 'DIANDIAN'" class="loading-spinner"></div>
                <img src="@/img/ic_stripe.svg" :alt="$t('recharge.diandian')" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'DIANDIAN' ? "Paying..." : "Diandian Pay" }}</span>
                <span class="payment-price">${{ select_recharge_item?.cent || '20.00' }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
            </button> -->

            <!-- HAIPAY_USDT 支付 -->
            <!-- <button 
              v-else-if="payType === 'HAIPAY_USDT'"
              class="payment-button"
              @click="haipayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content" :class="{ loading: clickPayItem === 'HAIPAY_USDT' }">
                <div v-if="clickPayItem === 'HAIPAY_USDT'" class="loading-spinner"></div>
                <img src="@/img/ic_stripe.svg" :alt="$t('recharge.haipay')" class="payment-icon">
                <span class="payment-text">{{ clickPayItem === 'HAIPAY_USDT' ? "Paying..." : "HaiPay USDT" }}</span>
                <span class="payment-price">${{ select_recharge_item?.cent || '20.00' }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
            </button> -->
          </div>
          <button 
              v-if="!isGuildGemUser && isPaymentMethodAvailable('AIRWALLEX')"
              class="payment-button"
              @click="airwallexPayClick"
              :disabled="!user || clickPayItem"
            >
              <div class="button-content">
                <img src="@/img/ic_airwallex.svg" :alt="$t('recharge.airwallex')" class="payment-icon">
                <span class="payment-text">{{ $t('recharge.airwallex') }}</span>
                <span class="payment-price">{{ getPaymentPrice(select_recharge_item) }}</span>
                <span class="original-price">(${{ select_recharge_item ? (select_recharge_item.coin / 50).toFixed(2) : '32.00' }})</span>
              </div>
              <PaymentDiscountBadge :label="getPaymentDiscount('AIRWALLEX')" />
            </button>
        </div>
      </div>
    </div>

    <!-- 加载遮罩 -->
    <div class="loading-overlay" v-if="loading">
      <div class="loader"></div>
      <span>{{ $t('recharge.coinsAreBeingDistributed') }}</span>
    </div>

    <RechargeResultModal
      :result="rechargeResult"
      @close="closeRechargeResult"
    />
  </div>
</template>

<script setup>
import Header from '#/components/Header/index.vue'
import { computed } from 'vue'
import { useOumiRecharge } from '../composables/useOumiRecharge'
import PaymentDiscountBadge from './PaymentDiscountBadge.vue'
import RechargeTypeTabs from './RechargeTypeTabs.vue'
import RechargeResultModal from './RechargeResultModal.vue'
import coinIcon from '@/img/recharge/oumi_coin.webp'
import gemIcon from '@/img/gem/gem_icon.webp'

const {
  loading,
  select_recharge_id,
  select_recharge_item,
  paypal_product_item,
  recharge_list,
  supportedPayTypes,
  user,
  user_id,
  isNewUser,
  clickPayItem,
  rechargeResult,
  activeRechargeType,
  gemRechargeAllowed,
  rechargeOptionsLoading,
  showRechargeOptions,
  showPaymentOptions,
  isGuildGemUser,
  isPhilippineCoinUser,
  canSubmitPhilippineCoins,
  philippineCoinTopUpClick,
  isPaymentMethodAvailable,
  getPaymentDiscount,
  getPaymentPrice,
  getCoinOriginalPrice,
  getRechargeAmount,
  getRechargePrice,
  airwallexPayClick,
  priceChangeHandle,
  checkUid,
  saveUid,
  closeRechargeResult,
  switchRechargeType,
  guildGemTopUpClick,
  stripePayClick,
  payermaxClick,
  diandianPayClick,
  pingpongClick,
  customPaypalClick,
  haipayClick,
} = useOumiRecharge()

const renderedPayTypes = [
  'STRIPE',
  'DIANDIAN',
  'PAYERMAX',
  'PAYERMAX_QRPH',
  'PAYPAL',
  'PINGPONG',
  'PINGPONG_QRPH',
]
const visiblePayTypes = computed(() => (
  supportedPayTypes.value.filter(payType => (
    renderedPayTypes.includes(payType) && isPaymentMethodAvailable(payType)
  ))
))
</script>

<style lang='scss' scoped>
.recharge-page {
//   width: 100%;
//   min-height: 100vh;
//   background: linear-gradient(135deg, #000000 0%, #1a1a2e 50%, #16213e 100%);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding: 20px;
//   box-sizing: border-box;
//   position: relative;


  width: 100%;
    min-height: 100vh;
    background: url('@/img/home/oumi-home-bg.webp') no-repeat center center;
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
    background-attachment: scroll;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    justify-content: flex-start;
    align-items: center;
}

:deep(.header) {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  flex: 0 0 124px;
}

.recharge-container {
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  position: relative;
  z-index: 1;
  padding-top: 184px;
  .first-bg {
    position: absolute;
    z-index: 0;
    top: 56px;
    left: 0;
    width: 100%;
    height: 180px;
    background: #1824B6;
    border-radius: 48px 48px 24px 24px;
    padding-top: 32px;
    padding-left: 64px;
    padding-right: 300px;
    box-sizing: border-box;
    .card-title {
      font-weight: 900;
      font-style: Black;
      font-size: 36px;
      line-height: 43px;
      text-transform: uppercase;
      color: #FBEB03;
    }
    .card-description {
      max-width: 520px;
      font-weight: 400;
      font-style: Regular;
      font-size: 20px;
      line-height: 24px;
      color: #FFFFFF;
      overflow-wrap: anywhere;
    }
    .gift-icon {
      position: absolute;
      top: -30px;
      right: 36px;
      width: 260px;
      height: auto;
    }
  }
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;

  .coin-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .page-title {
    font-size: 32px;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
    font-family: 'Poppins', sans-serif;
  }
}

.recharge-card {
  width: 100%;
  background: rgba(255, 255, 255, 0.08) url('@/img/recharge/recharge_bg.webp') no-repeat top center;
  background-size: cover;
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 40px 48px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 4px solid rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 0;
  }
  
  > * {
    position: relative;
    z-index: 1;
  }
}

.currency-tabs {
  margin: 0 auto 36px;
}

.gem-mode .original-price {
  display: none;
}

.option-skeleton {
  pointer-events: none;
  border-color: transparent !important;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.08) 25%,
    rgba(255, 255, 255, 0.16) 50%,
    rgba(255, 255, 255, 0.08) 75%
  ) !important;
  background-size: 200% 100% !important;
  animation: option-shimmer 1.2s linear infinite;
}

.gem-mode .coin-option.disabled {
  cursor: not-allowed;
  opacity: 0.42;
  filter: grayscale(0.4);
  border-color: rgba(255, 255, 255, 0.14);
  box-shadow: none;
}

@keyframes option-shimmer {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

.input-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;

  .input-label {
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 12px;
    font-family: 'Poppins', sans-serif;
    text-align: center;
  }

  .input-panel {
    width: 404px;
    max-width: 100%;
    overflow: hidden;
    border-radius: 12px;
    transition: background-color 0.3s ease;

    &.has-user {
      height: 92px;
      background: #0000003D;
    }
  }

  .user-input {
    width: 100%;
    height: 46px;
    padding: 0 16px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    font-size: 16px;
    color: #ffffff;
    font-family: 'Poppins', sans-serif;
    box-sizing: border-box;
    transition: all 0.3s ease;

    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
      font-weight: 400;
    }

    &:focus {
      outline: none;
      border-color: #FDF652;
      background: rgba(255, 255, 255, 0.15);
    }
  }

  .user-info {
    display: flex;
    align-items: center;
    height: 46px;
    padding: 0 16px;
    background: transparent;
    border-radius: 0 0 12px 12px;
    box-sizing: border-box;

    .user-avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      object-fit: cover;
      border: 1px solid #FFFFFF1F;
      margin-right: 10px;
    }

    .user-details {
      margin-right: 8px;
      .user-name {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 4px;
      }

      .user-uid {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.7);
      }
    }
    .first-top-up {
      background: rgba(253, 246, 82, 0.1);
      width: 72px;
      height: 20px;
      border-radius: 4px;
      line-height: 20px;
      text-align: center;
      font-size: 11px;
      font-weight: 500;
      color: #FBEB03;
    }
  }
}

.amount-section {
  margin-bottom: 32px;

  .section-label {
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 16px;
    font-family: 'Poppins', sans-serif;
    text-align: center;
  }

  .coin-options {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    justify-items: start;
  }

  .coin-option {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    padding: 20px 12px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      border-color: rgba(253, 246, 82, 0.5);
      transform: translateY(-2px);
    }

    &.active {
      background: rgba(253, 246, 82, 0.15);
      border-color: #FDF652;
      box-shadow: 0 0 20px rgba(253, 246, 82, 0.3);
    }

    .coin-amount {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      font-size: 20px;
      font-weight: 600;
      color: #ffffff;
      margin: 3px 0;

      .coin-icon-small {
        width: 20px;
        height: 20px;
      }
    }

    .coin-label {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
    }
  }
}

.payment-section {
  width: 480px;
  max-width: 100%;
  margin: 24px auto 0;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .payment-method {
    width: 100%;
  }

  .payment-button {
    position: relative;
    width: 100%;
    height: 48px;
    box-sizing: border-box;
    overflow: visible;
    background: #ffffff;
    border: none;
    border-radius: 24px;
    padding: 0 32px;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    font-family: 'Poppins', sans-serif;
    box-shadow: none;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }

    &:disabled {
      opacity: 1;
      cursor: not-allowed;
    }

    .button-content {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      position: relative;

      &.loading {
        opacity: 0.7;
      }

      .loading-spinner {
        width: 16px;
        height: 16px;
        border: 2px solid #333333;
        border-top: 2px solid transparent;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }

      .payment-icon {
        width: 32px;
        height: 32px;
        object-fit: contain;
      }

      .pp-payment-icon {
        width: auto;
        height: 24px;
        object-fit: contain;
      }

      .payment-text {
        font-size: 14px;
        font-weight: 600;
        color: #111111;
        white-space: nowrap;
      }

      .payment-price {
        font-size: 14px;
        font-weight: 600;
        color: #111111;
        white-space: nowrap;
      }

      .original-price {
        font-size: 14px;
        font-weight: 600;
        color: rgba(51, 51, 51, 0.3);
        text-decoration: line-through;
        margin-left: 0;
        white-space: nowrap;
      }
    }
  }
}

.guild-top-up-button {
  display: block;
  width: 360px;
  max-width: 100%;
  height: 54px;
  margin: 0 auto;
  padding: 0;
  border: 0;
  border-radius: 27px;
  color: #111111;
  background: #FDF652;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  cursor: pointer;

  &:hover:not(:disabled) {
    filter: brightness(1.03);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
}

.gem-top-up-button-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  white-space: nowrap;
}

.ph-coin-top-up-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(105deg, #fff86a 0%, #ffe24b 100%);
  box-shadow: 0 7px 20px rgba(255, 226, 75, 0.2);
  transition: filter 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &:hover:not(:disabled) {
    filter: brightness(1.025);
    box-shadow: 0 9px 24px rgba(255, 226, 75, 0.28);
    transform: translateY(-1px);
  }

  &:disabled {
    box-shadow: none;
  }
}

.ph-coin-discount-badge {
  top: -10px !important;
  right: 10px !important;
}

.ph-coin-button-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding-top: 3px;
}

.ph-coin-button-action {
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}

.ph-coin-button-content .payment-price,
.ph-coin-button-content .original-price {
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.ph-coin-button-content .original-price {
  color: rgba(51, 51, 51, 0.4);
  text-decoration: line-through;
}

.ph-coin-top-up-hint {
  margin-top: -2px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  color: white;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loader {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #FDF652;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

// 响应式设计
@media (max-width: 900px) {
  .recharge-page {
    padding: 16px;
  }

  .recharge-container {
    max-width: 100%;

    .first-bg {
      top: 56px;
      padding-left: 48px;
      padding-right: 260px;

      .card-title {
        font-size: 30px;
        line-height: 36px;
      }

      .card-description {
        max-width: 420px;
        font-size: 18px;
        line-height: 23px;
      }

      .gift-icon {
        right: 24px;
        width: 230px;
      }
    }
  }

  .page-header {
    .coin-icon {
      width: 32px;
      height: 32px;
    }

    .page-title {
      font-size: 24px;
    }
  }

  .recharge-card {
    padding: 24px 20px;
  }

  .recharge-card .amount-section .coin-options {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 10px;
  }

  .coin-option {
    width: 100%;
    padding: 16px 8px;

    .coin-amount {
      font-size: 18px;

      .coin-icon-small {
        width: 18px;
        height: 18px;
      }
    }

    .coin-label {
      font-size: 12px;
    }
  }
}

@media (max-width: 480px) {
  .page-header {
    .coin-icon {
      width: 28px;
      height: 28px;
    }

    .page-title {
      font-size: 20px;
    }
  }

  .recharge-card {
    padding: 20px 16px;
  }

  .recharge-card .amount-section .coin-options {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 8px;
  }

  .coin-option {
    width: 100%;
    padding: 12px 6px;

    .coin-amount {
      font-size: 16px;
      gap: 4px;

      .coin-icon-small {
        width: 16px;
        height: 16px;
      }
    }

    .coin-label {
      font-size: 11px;
    }
  }

  .payment-button {
    height: 48px;
    padding: 0 20px;

    .button-content {
      gap: 8px;

      .payment-icon {
        width: 24px;
        height: 24px;
      }

      .payment-text {
        font-size: 14px;
      }

      .payment-price {
        font-size: 14px;
      }

      .original-price {
        font-size: 12px;
      }
    }
  }
}

@media (max-width: 375px) {
  .recharge-card .amount-section .coin-options {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 8px;
  }
}
</style>
